import { useEffect, useRef, useState } from "react";
import { handleAuthCallback, consumePendingSignedInWorkspace } from "../auth";
import { useAuthStore } from "../authStore";
import { enableSignedInWorkspace } from "../store";

export function AuthCallback() {
  const setAuth = useAuthStore((s) => s.setAuth);
  const [error, setError] = useState<string | null>(null);
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code) {
      setError("Missing authorization code");
      return;
    }

    handleAuthCallback(code)
      .then(async (auth) => {
        setAuth(auth.user);

        // If the user was trying to activate the signed-in workspace before login
        if (consumePendingSignedInWorkspace()) {
          try {
            await enableSignedInWorkspace();
          } catch {
            // Signed-in workspace activation is best-effort here
          }
        }

        // Clean URL and redirect to app root
        window.history.replaceState({}, "", "/");
        window.location.reload();
      })
      .catch((err) => {
        setError(err instanceof Error ? err.message : "Authentication failed");
      });
  }, [setAuth]);

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center bg-surface text-zinc-400">
        <div className="max-w-sm text-center">
          <p className="mb-4 text-sm text-red-400">{error}</p>
          <a
            href="/"
            className="text-xs text-zinc-500 hover:text-zinc-300 underline"
          >
            Back to Spuerhund
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen items-center justify-center bg-surface text-zinc-400">
      <p className="text-sm">Signing in...</p>
    </div>
  );
}
